import { createFileRoute } from "@tanstack/react-router";
import BlogWhatIsAiFms from "@/pages/BlogWhatIsAiFms";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/what-is-ai-fms")({
  head: () => pageHead("/blog/what-is-ai-fms", "en"),
  component: BlogWhatIsAiFms,
});
